import { bool } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  useEstimateEditorStore,
  useEstimateStructure,
  useEstimateEditorSettings,
  useVisibilityModeCellClassName,
  ValueCell,
  VisibilityButton,
} from "@tools";

export const TeamCell = observer((cellProps) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { hideSummaryTeam } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryTeam);
  
  return (
    <ValueCell
      size="medium"
      isHeader
      className={className}
      style={{ cursor: allowEdition && "grab" }}
      { ...cellProps }
    >
      <span className="preset-tableSummaryHeader pt-teamMembers">
        { getFieldName("pt-teamMembers") }
      </span>
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny"
          inColumn right={-8}
          hidden={hideSummaryTeam}
          onChange={structure.visibility.setHideSummaryTeam}
        />
      }
    </ValueCell>
  )
})

TeamCell.propTypes = {
  extendPadding: bool,
}